import React from 'react'
import { HiOutlineCollection, HiTrendingUp, HiOutlineUser, HiOutlineCog, HiCheck, HiOutlineX, HiRefresh } from "react-icons/hi";
import { Dropdown, ToggleSwitch, TextInput, Label, Button, Badge } from 'flowbite-react'
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setProductConfig } from '../redux/productConfigSlice';
import { TbRobot } from "react-icons/tb";
import { getDeatailSetting } from '../services/ProductAPI';
import { fetchProducts, updateInterval, getInterval } from '../services/ProductAPI';
import { setCleanData } from '../redux/productSlice';
import { useSearchParams } from 'react-router-dom';
import { checkLimit } from '../services/ProductAPI'

function TableConfig() {
    const [forKaspi, setForKaspi] = useState('Для Kaspi')
    const [isActiveBot, setIsActiveBot] = useState('Включен бот')
    const [manager, setManager] = useState('Менеджер')
    const [hideFirstPositions, setHideFirstPositions] = useState(false)
    const [productWhithoutVideo, setProductWhithoutVideo] = useState(false)
    const [productWhithoutReviews, setProductWhithoutReviews] = useState(null)
    const [searchText, setSearch] = useState('')
    const [stockDaysMin, setStockDaysMin] = useState(null)
    const [stockDaysMax, setStockDaysMax] = useState(null)
    const [rating, setRatingCount] = useState(false)

    const [vip, setVip] = useState(false)
    const [size, setSize] = useState(false)
    const [promotional, setPromotional] = useState(false)

    const [botLogLowPrice, setBotLogLowPrice] = useState(false)
    const [botLogLowThreshold, setBotLogLowThreshold] = useState(false)

    const detailSetting = useSelector(state => state.productConfig.detailSetting)
    const firstPosition = useSelector(state => state.productConfig.firstPosition)
    const products = useSelector(state => state.product.products)
    const productConfig = useSelector(state => state.productConfig)

    const [searchParams, setSearchParams] = useSearchParams();
    const [limit, setLimit] = useState('')

    const [superBot, setSuperBot] = useState(false)

    const [hasImgReview, setHasImgReview] = useState(false)

    const [botInterval, setBotInterval] = useState('')
    const [botIntervalStyle, setBotIntervalStyle] = useState('gray')

    const dispatch = useDispatch()
    const resetSearchValues = () => {
        setForKaspi('Для Kaspi')
        setIsActiveBot('Включен бот')
        setManager('Менеджер')
        setHideFirstPositions(false)
        setProductWhithoutVideo(false)
        setSearch('')
        setStockDaysMin('')
        setStockDaysMax('')
        setRatingCount(false)
        setProductWhithoutReviews(null)
        setSuperBot(false)
        setSearchParams({ page: 1 })

        dispatch(
            setProductConfig({
                page: 1,
                title: ''
            })
        )

        dispatch(
            fetchProducts({
                page: 1,
                title: ''
            })
        )
        dispatch(
            setCleanData(true)
        )
    }



    useEffect(() => {
        const interval = setInterval(() => {
            checkLimit()
                .then(response => {
                    if (response.status === 'success') {
                        const timeString = response.result?.expiration_date?.split('T')[1].split('.')[0];
                        setLimit([response.result?.count_left, timeString]);
                    } else {
                        console.error(response);
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }, 5000);

        // call to api GET: /api/manage/v1/interval-update/?interval=240 . without interval
        const getbotInterval = () => {
            getInterval()
                .then(response => {
                    if (response.status === 'success') {
                        console.log(response)
                        setBotInterval(response.interval)
                    } else {
                        console.error(response);
                    }
                })
                .catch(error => {
                    console.error(error);
                });
        }
    
        getbotInterval()
        dispatch(
            setProductConfig({
                forKaspi: forKaspi === 'Для Kaspi' ? null : forKaspi,
                page: 1,
                isActiveBot: isActiveBot === 'Включен бот' ? null : isActiveBot,
                'manager': manager,
                stockDaysMin: stockDaysMin === 'stockDaysMin' ? null : stockDaysMin,
                stockDaysMax: stockDaysMax === 'stockDaysMax' ? null : stockDaysMax,
                hideFirstPositions: hideFirstPositions ? hideFirstPositions : null,
                rating: rating ? rating : null,
                productWhithoutVideo: productWhithoutVideo ? productWhithoutVideo : null,
                productWhithoutReviews: productWhithoutReviews ? productWhithoutReviews : null,
                vip: vip ? vip : null,
                size: size ? size : null,
                superBot: superBot ? superBot : null,
                promotional: promotional ? promotional : null,
                botLogLowThreshold: botLogLowThreshold ? botLogLowThreshold : null,
                botLogLowPrice: botLogLowPrice ? botLogLowPrice: null,
                hasImgReview: hasImgReview ? hasImgReview : null
            })
        )
        dispatch(
            getDeatailSetting()
        )
    }, [dispatch])

    let users = null
    if (detailSetting) {
        users = detailSetting.managers
    }
    const intervalUpdate = (val) => {
        updateInterval(val)
            .then(response => {
                if (response.status === 'success') {
                    console.log(response)
                } else {
                    console.error(response);
                }
            })
            .catch(error => {
                console.error(error);
            });
    }

    const handleInterval = (event) => {
        if (event.key === 'Enter' | event.key === '229') {
            intervalUpdate(botInterval)
            setBotIntervalStyle('success')
        }

    }


    const getSearch = () => {
        dispatch(
            setProductConfig({
                forKaspi: forKaspi === 'Для Kaspi' ? null : forKaspi,
                page: 1,
                isActiveBot: isActiveBot === 'Включен бот' ? null : isActiveBot,
                'manager': manager,
                stockDaysMin: stockDaysMin === 'stockDaysMin' ? null : stockDaysMin,
                stockDaysMax: stockDaysMax === 'stockDaysMax' ? null : stockDaysMax,
                hideFirstPositions: hideFirstPositions ? hideFirstPositions : null,
                rating: rating ? rating : null,
                productWhithoutVideo: productWhithoutVideo ? productWhithoutVideo : null,
                productWhithoutReviews: productWhithoutReviews ? productWhithoutReviews : null,
                title: searchText ? searchText : '',
                vip: vip ? vip : null,
                size: size ? size : null,
                superBot: superBot ? superBot : null,
                promotional: promotional ? promotional : null,
                botLogLowThreshold: botLogLowThreshold ? botLogLowThreshold : null,
                botLogLowPrice: botLogLowPrice ? botLogLowPrice: null,
                hasImgReview: hasImgReview ? hasImgReview : null
            })
        )
        dispatch(
            fetchProducts({
                forKaspi: forKaspi === 'Для Kaspi' ? null : forKaspi,
                page: 1,
                isActiveBot: isActiveBot === 'Включен бот' ? null : isActiveBot,
                'manager': manager,
                stockDaysMin: stockDaysMin === 'stockDaysMin' ? null : stockDaysMin,
                stockDaysMax: stockDaysMax === 'stockDaysMax' ? null : stockDaysMax,
                hideFirstPositions: hideFirstPositions ? hideFirstPositions : null,
                rating: rating ? rating : null,
                productWhithoutVideo: productWhithoutVideo ? productWhithoutVideo : null,
                productWhithoutReviews: productWhithoutReviews ? productWhithoutReviews : null,
                title: searchText ? searchText : '',
                vip: vip ? vip : null,
                size: size ? size : null,
                superBot: superBot ? superBot : null,
                promotional: promotional ? promotional : null,
                botLogLowThreshold: botLogLowThreshold ? botLogLowThreshold : null,
                botLogLowPrice: botLogLowPrice ? botLogLowPrice: null,
                hasImgReview: hasImgReview ? hasImgReview : null
            })
        )
        dispatch(
            setCleanData(true)
        )
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' | event.key === '229') {
            getSearch()
        }
    }

    return (<>
        <div className='pt-6 pb-6 px-4'>
            <ul className="space-y-1 list-inside text-gray-500 dark:text-gray-400">
                <li className="flex justify-between">
                    <div className='flex items-center'>
                        <HiOutlineCollection className="w-4 h-4 mr-1.5 lex-shrink-0" />
                        <p className='pr-2'>Количество товаров:</p><Badge
                            color="gray"
                            size="sm"
                            className='text-blue-600'
                        >
                            {products.count}
                            {/* {detailSetting && detailSetting.products} */}
                        </Badge>
                    </div>
                    {/* <div className='xs:hidden w-80 sm:block md:pr-16'>
                        <Progress
                            progress={0}
                            label="Парсинг товарв"
                            labelPosition="outside"
                            labelProgress={true}
                        />
                    </div> */}


                </li>
                <li className="flex items-center">
                    <HiTrendingUp className="w-4 h-4 mr-1.5 lex-shrink-0" />
                    <p className='pr-2'>Процент товаров на 1 месте:</p><Badge
                        color="gray"
                        size="sm"
                        className='text-blue-600'
                    >
                        {firstPosition && (firstPosition / products.all_products * 100).toFixed(1)} %
                    </Badge>
                </li>
                <li className="flex items-center">
                    <HiRefresh className="w-4 h-4 mr-1.5 lex-shrink-0" />
                    <p className='pr-2'>Осталось запросов:</p>
                    <Badge
                        color="gray"
                        size="sm"
                        className='text-blue-600 mr-2'
                    >{limit[0]} </Badge> 
                    {limit && ' до '}
                    <Badge
                        color="gray"
                        size="sm"
                        className='text-blue-600 ml-2'
                    >{limit[1]}</Badge>
                </li>
            </ul>
        </div>
        <div className='md:flex px-4 xs:pb-4 pt-4'>
            <div className="md:flex pb-2">
                <div className="relative">
                    <div className="absolute inset-y-0 left-0 md:bottom-2 flex items-center pl-3 pointer-events-none">
                        <svg className="w-5 h-6 text-gray-500" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd"></path></svg>
                    </div>
                    <input onKeyDown={handleKeyDown} type="text" value={searchText} onChange={e => setSearch(e.target.value)} id="search-navbar" className="block w-full mt-0.5 pb-1.5 p-2 pl-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-200 focus:border-blue-200 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-200 dark:focus:border-blue-200 " placeholder="Поиск..." />
                </div>
            </div>

            <Button.Group className='px-4 xs:hidden md:flex'>
                <Button color="gray"
                    onClick={getSearch}
                    className='pb-1'>
                    <HiCheck className="mr-3 h-4 text-base text-green-500" />
                    {' '}<p className='text-gray-500'>Найти</p>
                </Button>
                <Button color="gray"
                    onClick={resetSearchValues}
                    className='pb-1'>
                    <HiOutlineX className="mr-3 h-4 text-base text-gray-500" />
                    {' '}<p className='text-gray-500'>Сбросить</p>
                </Button>
            </Button.Group>

            <div className="md:flex md:gap-5 pb-4 md:px-16 transition-all xs:grid xs:grid-cols-2 xs:gap-y-2 xs:justify-items-center">
                <div className='w-44'>

                    <Dropdown
                        label={<><svg className='mr-2' width="16" height="16" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M16.7475 17.1513C19.6113 17.5934 19.9984 19.2879 20.2299 20.865L20.2685 21.1339L20.2948 21.3169L20.4342 22.245C20.707 24.0171 21.2762 27.6955 21.2762 29.615C21.2762 30.0947 21.234 30.4629 21.1569 30.6652C21.0284 30.977 20.654 31.2762 20.137 31.5256C18.8861 31.8335 17.5786 32 16.2318 32C16.0892 32 15.9489 31.9931 15.8081 31.9889C15.2638 31.8343 14.8547 31.5762 14.6381 31.2235C13.9841 30.1589 13.9447 27.787 13.9316 25.0152L13.9301 24.6937L13.9248 23.8629C13.9035 20.9286 13.8852 18.3986 14.9513 17.4907C15.3642 17.1415 15.9509 17.0259 16.7475 17.1513ZM10.5037 23.5398C11.1243 23.5049 11.5234 26.5574 11.6036 28.8721C11.6598 30.4836 11.4906 31.1465 11.2204 31.3845C10.9145 31.2824 10.6139 31.1719 10.3177 31.0519C10.1201 30.6928 9.96907 30.128 9.87312 29.3882C9.58018 27.0633 9.83465 23.5808 10.5037 23.5398ZM26.0622 28.1014C26.0235 28.3134 25.9689 28.4772 25.9016 28.6154C25.371 29.0412 24.8133 29.4321 24.2297 29.7838C24.0438 29.8151 23.8787 29.7933 23.798 29.6569C23.0245 28.2978 22.7342 24.0342 23.4827 23.6631C24.4586 23.1917 26.2069 27.3643 26.0622 28.1014ZM16.0008 0C24.7145 0 31.8006 6.90062 31.996 15.4873L32 15.7841V15.9213C31.984 19.8 30.5566 23.3486 28.205 26.0952C28.1197 26.0524 27.9641 25.9123 27.6822 25.4906C27.3905 25.0667 24.8749 21.1953 24.8749 16.7581C24.8749 15.8873 26.1301 14.527 27.2408 13.333C28.0711 12.4345 28.8576 11.587 29.1472 10.9209C29.5161 10.0614 29.258 9.46125 28.8498 9.25782C28.4803 9.07703 27.9256 9.2089 27.5363 9.9003C26.8975 11.0193 26.6928 11.2284 25.761 11.9771C24.8441 12.7254 23.3864 13.4787 23.3864 12.5036C23.3864 11.9771 24.1983 10.7847 24.5994 9.9489C25.009 9.10377 24.5675 8.49196 23.7217 8.49196C22.0608 8.49196 20.9583 10.6077 20.9583 11.3407C20.9583 12.0731 21.3136 12.1774 21.3136 13.0303C21.3136 13.8896 19.4913 15.0042 17.7747 15.0042C16.122 15.0042 15.1636 14.6697 14.7665 13.7273L14.7158 13.595L14.601 13.2554C14.1938 12.0653 13.9017 11.2022 13.3932 10.3002C13.1232 9.8232 12.7066 9.49252 12.3463 9.20156C11.8754 8.83579 11.6311 8.49901 11.5801 8.24784C11.5331 7.99865 11.5078 7.52904 12.3128 6.4465C13.1161 5.37014 13.2287 4.557 12.8267 4.13743C12.681 3.98817 12.4326 3.89254 12.1136 3.89254C11.5494 3.89254 10.7654 4.19149 9.95745 5.01265C8.7015 6.2996 9.41451 7.52149 9.41451 8.05788C9.41451 8.59392 9.18442 8.89713 8.43071 9.6264C7.67148 10.3589 7.40945 10.9869 7.32262 13.5109C7.28935 14.8114 7.06031 15.56 6.85471 16.2238C6.67705 16.8056 6.51366 17.3526 6.50483 18.1429C6.49076 19.0187 6.63654 19.5831 6.80666 20.2343C6.97369 20.8362 7.15109 21.5259 7.26475 22.6796C7.44553 24.4655 7.38268 25.9741 7.054 27.516L6.96628 27.9023L6.94578 28.0133C6.87847 28.2843 6.79846 28.6134 6.69031 28.7367C2.64076 25.8604 0 21.163 0 15.8531C0 7.09843 7.1635 0 16.0008 0Z" fill="#979797" />
                        </svg> <p className='text-gray-500 pr-4 w-20 text-start'>{forKaspi}</p>
                        </>}
                        dismissOnClick={true}
                        outline={true}
                        color="light"
                        fullSized={true}>
                        <Dropdown.Item className='w-36' onClick={e => setForKaspi('Да')}>
                            Да
                        </Dropdown.Item>
                        <Dropdown.Item onClick={e => setForKaspi('Нет')}>
                            Нет
                        </Dropdown.Item>
                        <Dropdown.Item onClick={e => setForKaspi('Для Kaspi')}>
                            По умолчанию
                        </Dropdown.Item>
                    </Dropdown>
                </div>
                <div className='w-44'>
                    <Dropdown
                        label={<><TbRobot style={{ color: 'gray', fontSize: '20px' }} className='mr-2' /> <p className='text-gray-500 w-20 text-start'>{isActiveBot}</p>
                        </>}
                        dismissOnClick={true}
                        outline={true}
                        color="light">
                        <Dropdown.Item className='w-36' onClick={e => setIsActiveBot('Да')}>
                            Да
                        </Dropdown.Item>
                        <Dropdown.Item onClick={e => setIsActiveBot('Нет')}>
                            Нет
                        </Dropdown.Item >
                        <Dropdown.Item onClick={e => setIsActiveBot('Включен бот')}>
                            По умолчанию
                        </Dropdown.Item >
                        <Dropdown.Divider />
                        <Dropdown.Item>
                        Интервал в секундах
                        </Dropdown.Item >
                       
                                <div className='flex w-full items-center ml-6'>
                                    <TextInput
                                        id="small"
                                        type="text"
                                        className='w-28'
                                        color={botIntervalStyle}
                                        value={botInterval}
                                        onChange={e => setBotInterval(e.target.value)}
                                        onKeyDown={handleInterval}
                                    />
                                    </div>
     
                    </Dropdown>
                </div>
                <div className='w-44'>
                    <Dropdown
                        label={<><HiOutlineUser style={{ color: 'gray', fontSize: '16px' }} className='mr-2' /> <p className='text-gray-500 w-20 truncate text-start'>{manager}</p>
                        </>}
                        dismissOnClick={true}
                        outline={true}
                        color="light"
                        fullSized={true}>
                        {users && users.map((user, index) => {
                            return (
                                <Dropdown.Item key={index} fullSized={true}>
                                    <div className='w-full h-full' onClick={value => setManager(value.target.innerHTML)}>
                                        {user.first_name}
                                    </div>
                                </Dropdown.Item>
                            );
                        })}
                        <Dropdown.Item fullSized={true}>
                            <div className='w-full h-full' onClick={value => setManager('Менеджер')}>
                                По умолчанию
                            </div>
                        </Dropdown.Item>
                    </Dropdown>
                </div>
                <div className='w-44'>
                    <Dropdown
                        label={<><HiOutlineCog style={{ color: 'gray', fontSize: '16px' }} className='mr-2' /> <p className='text-gray-500 w-20'>Остальное</p>
                        </>}
                        dismissOnClick={false}
                        outline={true}
                        color="light">
                        <Dropdown.Item>
                            <label className="inline-flex relative items-center cursor-pointer pr-2">
                                <input
                                    checked={hideFirstPositions}
                                    onChange={value => { hideFirstPositions ? setHideFirstPositions(false) : setHideFirstPositions(true) }}
                                    type="checkbox" value="" className="sr-only peer" />
                                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Скрыть 1-ые позиции</span>
                            </label>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <label className="inline-flex relative items-center cursor-pointer pr-2">
                                <input
                                    checked={productWhithoutVideo}
                                    onChange={value => { productWhithoutVideo ? setProductWhithoutVideo(false) : setProductWhithoutVideo(true) }}
                                    type="checkbox" value="" className="sr-only peer" />
                                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Товары без видео</span>
                            </label>
                        </Dropdown.Item>

                        <Dropdown.Item>
                            <label className="inline-flex relative items-center cursor-pointer pr-2">
                                <input
                                    checked={hasImgReview}
                                    onChange={value => { hasImgReview ? setHasImgReview(false) : setHasImgReview(true) }}
                                    type="checkbox" value="" className="sr-only peer" />
                                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Товары без фото в комментариях</span>
                            </label>
                        </Dropdown.Item>

                        
                        {/* <Dropdown.Item>
                            <label className="inline-flex relative items-center cursor-pointer pr-2">
                                <input
                                    checked={productWhithoutReviews}
                                    onChange={value => { productWhithoutReviews ? setProductWhithoutReviews(null) : setProductWhithoutReviews('0') }}
                                    type="checkbox" value="" className="sr-only peer" />
                                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Товары без отзывов</span>
                            </label>
                        </Dropdown.Item> */}
                        <Dropdown.Item>
                            <label className="inline-flex relative items-center cursor-pointer pr-2">
                                <input
                                    checked={rating}
                                    onChange={value => { rating ? setRatingCount(false) : setRatingCount(true) }}
                                    type="checkbox" value="" className="sr-only peer" />
                                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Рейтинг ниже 3 </span>
                            </label>
                        </Dropdown.Item>

                        <Dropdown.Item>
                            <label className="inline-flex relative items-center cursor-pointer pr-2">
                                <input
                                    checked={vip}
                                    onChange={value => { vip ? setVip(false) : setVip(true) }}
                                    type="checkbox" value="" className="sr-only peer" />
                                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">VIP</span>
                            </label>
                        </Dropdown.Item>

                        <Dropdown.Item>
                            <label className="inline-flex relative items-center cursor-pointer pr-2">
                                <input
                                    checked={promotional}
                                    onChange={value => { promotional ? setPromotional(false) : setPromotional(true) }}
                                    type="checkbox" value="" className="sr-only peer" />
                                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Акционные</span>
                            </label>
                        </Dropdown.Item>

                        <Dropdown.Item>
                            <label className="inline-flex relative items-center cursor-pointer pr-2">
                                <input
                                    checked={size}
                                    onChange={value => { size ? setSize(false) : setSize(true) }}
                                    type="checkbox" value="" className="sr-only peer" />
                                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Габарит</span>
                            </label>
                        </Dropdown.Item>

                        <Dropdown.Item>
                            <label className="inline-flex relative items-center cursor-pointer pr-2">
                                <input
                                    checked={superBot}
                                    onChange={value => { superBot ? setSuperBot(false) : setSuperBot(true) }}
                                    type="checkbox" value="" className="sr-only peer" />
                                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Турбо бот</span>
                            </label>
                        </Dropdown.Item>

                        <Dropdown.Item>
                            <label className="inline-flex relative items-center cursor-pointer pr-2">
                                <input
                                    checked={botLogLowPrice}
                                    onChange={value => { botLogLowPrice ? setBotLogLowPrice(false) : setBotLogLowPrice(true) }}
                                    type="checkbox" value="" className="sr-only peer" />
                                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Low price log</span>
                            </label>
                        </Dropdown.Item>



                        <Dropdown.Item>
                            <label className="inline-flex relative items-center cursor-pointer pr-2">
                                <input
                                    checked={botLogLowThreshold}
                                    onChange={value => { botLogLowThreshold ? setBotLogLowThreshold(false) : setBotLogLowThreshold(true) }}
                                    type="checkbox" value="" className="sr-only peer" />
                                <div class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                                <span class="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">Lower threshold reached log</span>
                            </label>
                        </Dropdown.Item>


                        <Dropdown.Divider />
                        <Dropdown.Item>

                            <div className="mb-2 w-40">
                                <Label
                                    htmlFor="small"
                                    value="Максимум отзывов"
                                />
                            </div>
                            <div className='flex w-full items-center'>
                                <TextInput
                                    id="small"
                                    type="text"
                                    className='w-20'
                                    value={productWhithoutReviews}
                                    onChange={value => setProductWhithoutReviews(value.target.value)}
                                />
                            </div>
                        </Dropdown.Item>

                        <Dropdown.Item>
                            <div>
                                <div className="mb-2 w-full">
                                    <Label
                                        htmlFor="small"
                                        value="На складе"
                                    />
                                </div>
                                <div className='flex w-full items-center'>
                                    <TextInput
                                        id="small"
                                        type="text"
                                        className='w-20'
                                        value={stockDaysMin}
                                        onChange={value => setStockDaysMin(value.target.value)}
                                    />—
                                    <TextInput
                                        id="small"
                                        type="text"
                                        className='w-20'
                                        value={stockDaysMax}
                                        onChange={value => setStockDaysMax(value.target.value)}
                                    />
                                </div>
                            </div>
                        </Dropdown.Item>
                    </Dropdown>
                </div>
            </div>
            <div className='md:hidden flex justify-center gap-2'>
                <div className='w-44 pr-2'>
                    <Button color="gray" className='w-full bg-gray-100'
                        onClick={getSearch}>
                        <HiCheck className="mr-3 h-4 text-base text-green-500" />
                        {' '}<p className='text-gray-500'>Найти</p>
                    </Button>
                </div>
                <div className='w-44 pr-2'>
                    <Button color="gray" className='w-full bg-gray-50'
                        onClick={resetSearchValues}>
                        <HiOutlineX className="mr-3 h-4 text-base text-gray-500" />
                        {' '}<p className='text-gray-500'>Сбросить</p>
                    </Button>
                </div>
            </div>

        </div>

    </>
    )
}

export default TableConfig